import CloseIcon from './assets/close.svg';
import './CloseButton.css';

function CloseButton({ className = '', onClose }: { className?: string; onClose: () => void }) {
    return (
        <div aria-label='close-button' className={`${className || 'close-container'} cursor-pointer`} onClick={onClose}>
            <CloseIcon className='cursor-pointer' />
        </div>
    );
}

export { CloseButton };
